import type { DictaphoneDeviceFingerprint } from 'generated/graphql';

export interface UsbIds {
  vendorId: number;
  productId: number;
}

// Chrome appends the USB `(vendor:product)` hex ids to audio input labels on macOS and Windows,
// e.g. `Microphone (2- SpeechMike III) (0911:0fa0)`.
const USB_IDS_LABEL_SUFFIX = /\(([0-9a-f]{4}):([0-9a-f]{4})\)\s*$/i;

/** Parse the trailing USB vendor/product ids from a media device label, if present. */
export function parseUsbIdsFromLabel(label: string): UsbIds | null {
  const match = USB_IDS_LABEL_SUFFIX.exec(label);
  if (match == null) return null;

  const [, vendorHex, productHex] = match;
  return { vendorId: parseInt(vendorHex, 16), productId: parseInt(productHex, 16) };
}

/** Build a dictaphone fingerprint for an audio input from its label and any USB ids it carries. */
export function toAudioInputFingerprint({
  label,
}: Pick<MediaDeviceInfo, 'label'>): DictaphoneDeviceFingerprint {
  return { deviceLabel: label, ...parseUsbIdsFromLabel(label) };
}
